import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'
import store from './store/'

import * as STdata from './data/data.json'
import { bus } from './main';
import AppStart from './components/AppStart.vue'

Vue.use(Router)

const routes: RouteConfig[] = [
    {
        path: '/',
        name: 'Start',
    },
    {
        path: '/test',
        name: 'Test'
    },
	{
		path: '/stelling/:statementId',
		name: 'Statement'
	},
	{
		path: '/resultaten',
		name: 'Results'
	},
	{
		path: '*',
		redirect: { name: 'Statement', params: { statementId: '1' }}
	}
]

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
    const choices = store.getters.choices
  
    if (to.path === '/') {
      next()
    } else {
        if (to.params.statementId === '1') {
            next()
        }
        if (to.name === 'Results') {
            if (choices.length === STdata.default.statements.length) {
            next()
            } else {
            next({ name: 'Statement', params: { statementId: '1' }})
            }
        } else if (choices[Number(to.params.statementId) - 2] !== undefined) {
            next()
        } else {
            next({ name: 'Statement', params: { statementId: '1' }})
        }
    }
  })
  
  
router.afterEach((to, from) => {
    if (to.name === 'Results') {
      store.dispatch('setCurrentStatementId', STdata.default.statements.length)
      bus.$emit('changeDirection', 'next')
    } else {
      const oldStatementId = store.getters.currentStatementId
      store.dispatch('setCurrentStatementId', Number(to.params.statementId) - 1)
      bus.$emit('changeDirection', (oldStatementId > Number(to.params.statementId) - 1 ? 'previous' : 'next'))
    }
  })  

export default router
